import { setLocalFontSetting } from './formats/local-font-setting'
import {
  askForLocalFonts,
  LOCAL_FONT_ACCESS_NOTE,
  type LocalFontAccess,
  useLocalFontAccess,
} from './formats/local-page-fonts'
import { FieldSection, SettingBlock, Toggle } from './index'

function fontsDescription(access: LocalFontAccess | null): string {
  return (
    (access && LOCAL_FONT_ACCESS_NOTE[access]) ??
    'A page that names a font installed here previews and prints in it. The faces it names are sent with each PDF you download, for that one print.'
  )
}

/**
 * What this browser does, held on the device rather than the account: the
 * answer differs from one computer to the next, so it is asked of each.
 */
export function AccountDevice() {
  const access = useLocalFontAccess()
  return (
    <FieldSection
      title="This computer"
      description="These apply to this browser alone. Another computer you sign in on answers them for itself."
    >
      <SettingBlock
        title="Use fonts on this computer"
        description={fontsDescription(access)}
      >
        <Toggle
          label="Use fonts on this computer"
          hideLabel
          checked={access === 'granted'}
          disabled={
            access === null || access === 'denied' || access === 'unsupported'
          }
          // The browser shows its prompt only during the click itself, so the
          // ask is made here rather than after any other work.
          onChange={(next) => {
            if (next) void askForLocalFonts()
            else setLocalFontSetting('off')
          }}
        />
      </SettingBlock>
    </FieldSection>
  )
}
